import { store } from "@gsk-tech/gsk-react-framework";
import { IUIProps } from "../gsk-main/gsk-main-component/gsk-main";
import { useDispatch } from "react-redux";
import { Col, Image, Row } from "antd";
import logo from "@gsk-tech/gsk-react-framework/src/images/gsk-logo.png";
import "./upbar.css";
import { SelectedPageContainer } from "./sub-components/selected-page-container/selected-page-container";
import { UserDropdown } from "./sub-components/user-dropdown/user-dropdown";
import { MenuButtons } from "./sub-components/uppbar-menu-buttons/menu-buttons";
import { logout } from "../../store/sso/src";

interface UpbarProps {
  ui: IUIProps;
}

export const Upbar = ({ ui }: UpbarProps) => {
  const dispatch: any = useDispatch();

  const handleLogoutClick = () => {
    dispatch(ui.headerMenu.loggedOutaction);
    logout();
  };

  const username = store.getState()?.loggedInUser?.mudid;

  return (
    <div className="header-container">
      <Row className="gsk-header-menu">
        <Row justify="start">
          <Col
            style={{
              alignItems: "center",
              display: "flex",
              flexWrap: "nowrap",
              justifyContent: "right",
              padding: 0,
            }}
          >
          <a href="/">   <Image src={logo} style={{ width: 120 }} preview={false} /> </a>
          <a href="/"> 
            <Col
              style={{
                display: "table",
                lineHeight: 1,
                padding: 2,
                verticalAlign: "middle",
                alignItems: "flex-start",
              }}
            >
              <Col className="gsk-title-class-overwrite">
                {ui.headerMenu.title}
              </Col>
              <Col className="titleDescriptionClass">
                {ui.headerMenu.description}
              </Col>
            </Col>
            </a>
          </Col>
        </Row>
        <Row justify="end" align="middle">
          <Col>
            <SelectedPageContainer {...ui.selectedPageContainer} />
          </Col>
          <Col>
            <MenuButtons />
          </Col>
          <Col>
            <UserDropdown
              theme={ui.theme}
              username={username}
              handleLogout={handleLogoutClick}
              handleProfileClick={() => console.log("profile")}
              items_paths={ui.sideMenu.items}
            />
          </Col>
        </Row>
      </Row>
    </div>
  );
};
